var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.28125,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 13H11V15H27V13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31H11V33H27V31Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33H13V27.58L17.59 23L13 18.41V14H15V17.58L20.41 23L15 28.41V33Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0038 33H23.0038V28.41L17.5938 23L23.0038 17.58V14H25.0038V18.41L20.4138 23L25.0038 27.58V33Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 28H30C29.2044 28 28.4413 27.6839 27.8787 27.1213C27.3161 26.5587 27 25.7956 27 25H29C29 25.2652 29.1053 25.5196 29.2929 25.7071C29.4804 25.8946 29.7348 26 30 26H32C32.2652 26 32.5196 25.8946 32.7071 25.7071C32.8946 25.5196 33 25.2652 33 25C33 24.7348 32.8946 24.4804 32.7071 24.2929C32.5196 24.1054 32.2652 24 32 24H30C29.2044 24 28.4413 23.6839 27.8787 23.1213C27.3161 22.5587 27 21.7956 27 21C27 20.2044 27.3161 19.4413 27.8787 18.8787C28.4413 18.3161 29.2044 18 30 18H32C32.7956 18 33.5587 18.3161 34.1213 18.8787C34.6839 19.4413 35 20.2044 35 21H33C33 20.7348 32.8946 20.4804 32.7071 20.2929C32.5196 20.1054 32.2652 20 32 20H30C29.7348 20 29.4804 20.1054 29.2929 20.2929C29.1053 20.4804 29 20.7348 29 21C29 21.2652 29.1053 21.5196 29.2929 21.7071C29.4804 21.8946 29.7348 22 30 22H32C32.7956 22 33.5587 22.3161 34.1213 22.8787C34.6839 23.4413 35 24.2044 35 25C35 25.7956 34.6839 26.5587 34.1213 27.1213C33.5587 27.6839 32.7956 28 32 28Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27H30V29H32V27Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17H30V19H32V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv11);
export default __webpack_public_path__ + "static/media/div11.768993573d97656eda2e718b5b2937b9.svg";
export { ForwardRef as ReactComponent };